//returns the type of form fields and their relevant types like inputbox or drop down

export const CategoryForm = (selectedCategory) =>{
    console.log("category in category forms", selectedCategory);
    if(selectedCategory === "Painting"){
        return {
            SubCategory  :  [
                {
                    id : 1,
                    subCategoryName :  "Water Proofing",
                },
                {
                    id : 2,
                    subCategoryName :  "Interior Painting"
                }, 
                {
                    id : 3,
                    subCategoryName :  "Exterior Painting"
                },
                {
                    id: 4, 
                    subCategoryName :  "Texture Painting"
                }
            ],
            
        }
    }else if(selectedCategory === "AC Repairs"){
        return {
            SubCategory  :  [
                {
                    id : 1,
                    subCategoryName :  "AC Repairs",
                },
                {
                    id : 2,
                    subCategoryName :  "Gas Filling"
                }, 
                {
                    id : 3,
                    subCategoryName :  "AC service"
                },
                {
                    id: 4, 
                    subCategoryName :  "Installation or dismantle"
                }
            ],
            
        }
    }else if(selectedCategory=== "Cleaning"){
        return {
            SubCategory :[
            {
                id: 1,
                subCategoryName: "Full house cleaning",
                subCategoryDetails : [
                    {
                        id: 1,
                        subCategoryDetailsName : "Unfurnished Home (Silver)", 
                    },
                    {
                        id :2,
                        subCategoryDetailsName :'Unfurnished Home (Gold)'
                    }, {
                        id : 3, 
                        subCategoryDetailsName: "Furnished Home (Silver)",
                    },
                    {
                        id: 4,
                        subCategoryDetailsName :"Furnished Home (Gold)"
                    }
                ]
            }, 
            {
                id: 2, 
                subCategoryName : "Kitchen cleaning",
                subCategoryDetails :[
                    {
                        id: 1,
                        subCategoryDetailsName : "Full Kitchen cleaning ( non-vacant )",
                        price : 1399,
                        tax:  50, 
                        total : 1449
                    }, {
                        id : 2,
                        subCategoryDetailsName :"Full kitchen cleaning with chimney ( non-vacant ) ",
                        price : 1849,
                        tax : 50, 
                        total : 1899
                    }, 
                    {
                        id : 3,
                        subCategoryDetailsName :"Full kitchen cleaning with Appliance cleaning ( non-vacant ) ", 
                        price :  1949,
                        tax:  50, 
                        total : 1999
                    }, 
                    {
                        id : 4,
                        subCategoryDetailsName :"Full kitchen cleaning with Appliance and chimney cleaning ( non-vacant ) ", 
                        price : 2349,
                        tax : 50,
                        total : 2399
                    }, 
                    {
                        id: 5,
                        subCategoryDetailsName : "Full Kitchen cleaning ( vacant )",
                        price: 999,
                        tax:  50,
                        total: 1049
                    },
                    {
                        id: 6,
                        subCategoryDetailsName : "Full Kitchen cleaning with chimney ( vacant )",
                        price: 1399,
                        tax:  50,
                        total: 1449
                    },
                    {
                        id: 7,
                        subCategoryDetailsName : "Full Kitchen cleaning with Appliance cleaning ( vacant )",
                        price: 1539,
                        tax:  50,
                        total: 1589
                    },
                    {
                        id: 8,
                        subCategoryDetailsName : "Full Kitchen cleaning with Appliance and chimney cleaning ( vacant )",
                        price: 1939,
                        tax:  50,
                        total: 1989
                    }
                ]
            }
            ]
        }
    }else if(selectedCategory === "Bathroom Cleaning"){
        return{
            SubCategory: [
                {
                    id:  1, 
                    subCategoryName: 'Bathroom cleaning (Silver)'
                }, {
                    id : 2,
                    subCategoryName : "Bathroom Cleaning (Gold)"
                }
            ],
        }

    }else if (selectedCategory === "Sofa Cleaning"){
        return{
            SubCategory :[
                {
                    id : 1, 
                    subCategoryName : "2 seater",
                    price: 299, 
                    tax: 50, 
                    total: 349
                },
                {
                    id : 2, 
                    subCategoryName : "3 seater",
                    price: 369, 
                    tax: 50, 
                    total: 419
                },
                {
                    id : 3, 
                    subCategoryName : "4 seater",
                    price: 489, 
                    tax: 50, 
                    total: 539
                },
                {
                    id : 4, 
                    subCategoryName : "5 seater",
                    price: 599, 
                    tax: 50, 
                    total: 649
                },
                {
                    id : 5, 
                    subCategoryName : "6 seater",
                    price: 689, 
                    tax: 50, 
                    total: 739
                },
                {
                    id : 6, 
                    subCategoryName : "7 seater",
                    price: 799, 
                    tax: 50, 
                    total: 849
                },
                {
                    id : 7, 
                    subCategoryName : "8 seater",
                    price: 889, 
                    tax: 50, 
                    total: 939
                },
                {
                    id : 8, 
                    subCategoryName : "9 seater",
                    price: 999, 
                    tax: 50, 
                    total: 1049
                },
                {
                    id : 9, 
                    subCategoryName : "10 seater",
                    price: 1109, 
                    tax: 50, 
                    total: 1159
                }
            ]
        }
    }
}


export const FlatType = () =>{
    return [
        // {
        //     id : 0,
        //     subCategoryName : "1 RK"
        // },
        {
            id : 1,
            subCategoryName : "1 BHK"
        },
        {
            id:2,
            subCategoryName: "2 BHK"
        },
        {
            id :3,
            subCategoryName : "3 BHK"
        },
        {
            id : 4,
            subCategoryName: "4 BHK"
        },
        {
            id : 5,
            subCategoryName: "5 BHK"
        }
    ]
}

export const priceList  = (selectedCategory, selectedSubCategoryName,subCategoryDetails, flatType) =>{
    if(selectedCategory === "Cleaning" && selectedSubCategoryName === "Full house cleaning"){
        if(subCategoryDetails === "Unfurnished Home (Silver)"){
            if(flatType === "1 BHK"){
                return {
                    price : 1999, 
                    tax : 199, 
                    total : 2198
                }
            }else if(flatType === "2 BHK"){
                return {
                   price : 2299,
                   tax:  299, 
                   total : 2598
                }
            }else if(flatType === "3 BHK"){
                return {
                    price : 2899, 
                    tax : 399,
                    total: 3298
                }
            }else if(flatType === "4 BHK"){
                return {
                    price : 3899, 
                    tax : 399, 
                    total: 4298
                }
            }else return {
                price : 4399, 
                tax : 499, 
                total: 4898
            }
        }else if(subCategoryDetails === "Unfurnished Home (Gold)"){
            if(flatType === "1 BHK"){
                return {
                    price : 3199, 
                    tax : 299, 
                    total: 3498
                }
            }else if(flatType === "2 BHK"){
                return {
                   price : 3698,
                   tax:  399, 
                   total: 4097
                }
            }else if(flatType === "3 BHK"){
                return {
                    price : 4599, 
                    tax : 499, 
                    total: 5098
                }
            }else if(flatType === "4 BHK"){
                return {
                    price : 5999, 
                    tax : 599, 
                    total: 6598
                }
            }else return {
                price : 6799, 
                tax : 599, 
                total: 7398
            }

        } else if(subCategoryDetails === "Furnished Home (Silver)"){
            if(flatType === "1 BHK"){
                return {
                    price : 2399, 
                    tax : 199, 
                    total : 2598
                }
            }else if(flatType === "2 BHK"){
                return {
                   price : 2799,
                   tax:  299, 
                   total : 3098
                }
            }else if(flatType === "3 BHK"){
                return {
                    price : 3599, 
                    tax : 399,
                    total: 3998
                }
            }else if(flatType === "4 BHK"){
                return {
                    price : 4399, 
                    tax : 499, 
                    total: 4898
                }
            }else return {
                price : 4699, 
                tax : 499, 
                total: 5198
            }
        }else if(subCategoryDetails ===  "Furnished Home (Gold)"){
            if(flatType === "1 BHK"){
                return {
                    price : 3599, 
                    tax : 399, 
                    total : 3998
                }
            }else if(flatType === "2 BHK"){
                return {
                   price : 3999,
                   tax:  499, 
                   total : 4498
                }
            }else if(flatType === "3 BHK"){
                return {
                    price : 4599, 
                    tax : 499,
                    total: 5098
                }
            }else if(flatType === "4 BHK"){
                return {
                    price : 6399, 
                    tax : 599, 
                    total: 6998
                }
            }else return {
                price : 7399, 
                tax : 599, 
                total: 7998
            }
        }
       

    }else if(selectedCategory === "Bathroom Cleaning" && selectedSubCategoryName === 'Bathroom cleaning (Silver)'){

        if(flatType === "1 BHK"){
                return {
                    price : 309, 
                    tax : 50, 
                    total : 359
                }
            }else if(flatType === "2 BHK"){
                return {
                   price : 599,
                   tax:  70, 
                   total : 669
                }
            }else if(flatType === "3 BHK"){
                return {
                    price : 879, 
                    tax : 99,
                    total: 978
                }
            }else if(flatType === "4 BHK"){
                return {
                    price : 999, 
                    tax : 99, 
                    total: 1098
                }
            }else return {
                price : 1149, 
                tax : 149, 
                total: 1348
            }
    }else if(selectedCategory === "Bathroom Cleaning" && selectedSubCategoryName === 'Bathroom Cleaning (Gold)'){

        if(flatType === "1 BHK"){
                return {
                    price : 409, 
                    tax : 50, 
                    total : 459
                }
            }else if(flatType === "2 BHK"){
                return {
                   price : 709,
                   tax:  149, 
                   total : 858
                }
            }else if(flatType === "3 BHK"){
                return {
                    price : 1099, 
                    tax : 149,
                    total: 1248
                }
            }else if(flatType === "4 BHK"){
                return {
                    price : 1259, 
                    tax : 199, 
                    total: 1458
                }
            }else return {
                price : 1449, 
                tax : 199, 
                total: 1848
            }
    }
}


export const slots = (selectedCategory) =>{
    // if(selectedCategory === "Painting" || selectedCategory === "AC Repairs" ||selectedCategory=== "Carpenter Services")
     if (selectedCategory === "Home Cleaning"){
        return [
            {

                id : 1, 
                timeSlot :  "10 am - 12 pm"
            },
            {

                id : 2, 
                timeSlot :  "12 pm - 2 pm"
            },
            {

                id : 3, 
                timeSlot :  "2 pm - 5 pm"
            },
            {

                id : 4, 
                timeSlot :  "5 pm - 7 pm"
            },
            
        ]

    }else if(selectedCategory === "Sofa Cleaning"){
        return [
            {

                id : 1, 
                timeSlot :  "10 am - 12 pm"
            },
            {

                id : 2, 
                timeSlot :  "12 pm - 2 pm"
            },
            {

                id : 3, 
                timeSlot :  "2 pm - 5 pm"
            },
            {

                id : 4, 
                timeSlot :  "5 pm - 7 pm"
            },
            
        ]
    }else if( selectedCategory === "Bathroom Cleaning"){
        return [
            {

                id : 1, 
                timeSlot :  "10 am - 12 pm"
            },
            {

                id : 2, 
                timeSlot :  "12 pm - 2 pm"
            },
            {

                id : 3, 
                timeSlot :  "2 pm - 5 pm"
            },
            {

                id : 4, 
                timeSlot :  "5 pm - 7 pm"
            },
            
        ]
    }else{
        return [
            {
                id: 1, 
                timeSlot : "10 am - 11 am"
            }, {
                id : 2,
                timeSlot: "11 am - 12 pm"
            },
            {
                id: 3, 
                timeSlot : "12 pm - 1 pm"
            },{
                id: 4, 
                timeSlot : "1 pm -2 pm"
            },{

                id : 5, 
                timeSlot :  "2 pm - 3 pm"
            },
            {

                id : 6, 
                timeSlot :  "3 pm - 4 pm"
            },
            {

                id : 7, 
                timeSlot :  "5 pm - 6 pm"
            },
            {

                id : 8, 
                timeSlot :  "6 pm - 7 pm"
            },
          
        ]
    }

}





// ac -> ac repair, gas filling , ac installation, demantle, ac service
//
